import './main.less';

// import { useHideMobileFooter } from '@/features/mobile/hooks';
// import WhiteListMask from '@/pages/components/WhitelistMask';
import { Layout as AntLayout } from 'antd';
import cls from 'classnames';

import { useMediaQueryDevice } from '@/components/MediaQuery';
import { useIsPlainBgPage } from '@/hooks';

const { Content } = AntLayout;

export default function Main({ children }: { children: JSX.Element }): JSX.Element {
  const { deviceType } = useMediaQueryDevice();
  const isPlainBg = useIsPlainBgPage();

  // const hideFooter = useHideMobileFooter();
  return (
    <Content
      id="pageLayout"
      className={cls(`main-container syn-scrollbar  ${deviceType}  ${false ? 'hide-footer' : ''}`)}>
      {/* <WhiteListMask /> */}
      {/* {!isPlainBg && !isMobile && (
        <div className="main-bg">
          <img loading="lazy" src={theme.dataTheme === THEME_ENUM.DARK ? bgMeshDark : bgMesh} />
        </div>
      )} */}

      <div className={cls('main-body-wrap', isPlainBg && 'full-width')}>
        <div className="main-body">{children}</div>
      </div>
    </Content>
  );
}
